module.exports = __webpack_public_path__ + "static/media/paraicon4.c9a81aa0.webp";